import React from "react";
import { Route, Routes } from "react-router-dom";
import ApplicantInformatonPage from "../../Containers/ApplicantInformatonPage";
import ProjectInformationModule from "../../Pages/ProjectInformationPage/ProjectInformationModule";
import ProjectInformationPage from "../../Containers/ProjectInformationPage";
import InformationTargetGroupProjectModule from "../../Pages/ProjectInformationPage/InformationTargetGroupProjectModule";
import ProjectWorkPlanModule from "../../Pages/ProjectInformationPage/ProjectWorkPlanModule";
import ExpectedUnoactProjectTargetGroupModule from "../../Pages/ProjectInformationPage/ExpectedUnoactProjectTargetGroupModule";
import SectoreInformationProjectUniquenessModule from "../../Pages/ProjectInformationPage/SectoreInformationProjectUniquenessModule";
import TeamMembersModule from "../../Pages/ProjectInformationPage/TeamMembersModule";

import BudgetTimeFrame from "../../Containers/BudgetTimeFrame";

import MainPage from "../../Pages/MainPage";
import AdvertisingAndMediaPlan from "../../Containers/AdvertisingAndMediaPlan";
import Attachments from "../../Containers/AttachmentsAndPledge";
import YesNoTable from "../../Components/yesNoTable";

import ReportStageContainer from "../../ContainersManager/ReportStageContainer";

import JobOpportunitiesDuringProject from "../../PagesReportStage/JobOpportunitiesDuringProject";
import OpportunitiesObtained from "../../PagesReportStage/OpportunitiesObtained";
import ChallengesEncountered from "../../PagesReportStage/ChallengesEncounteredThatAffected";
import SuccessStory from "../../PagesReportStage/SuccessStory";
import EventsActivitiesNextFlow from "../../PagesReportStage/EventsActivitiesNextFlow";
import EventsActivities from "../../PagesReportStage/EventsActivities";
import ReportsStagesSubmitter from "../../Pages/ReportsStagesSubmitter";

import TransferItemInformationSubmitter from "../../Pages/TransferItemInformationSubmitter";

import TechnicalReportNotes from "../../PagesReportStage/TechnicalReportNotes";



const MainRoutesSupmiter = () => {
  return (
    <Routes>
      <Route path="/grants/" element={<MainPage />} />

      <Route path="/grants/MainPage" element={<MainPage />} />
      <Route
        path="/grants/ApplicationInformation"
        element={<ApplicantInformatonPage />}
      />
      {/* <Route
        path="/grants/testjob"
        element={
          <JobOpportunitiesDuringProject
            pR_ReportsStagesGuid={"78563532-98a0-480f-a656-7ba0fdc03c16"}
          />
        }
      /> */}
      {/* <Route
        path="/grants/testjob"
        element={
          <EventsActivities
            pR_ReportsStagesGuid={"78563532-98a0-480f-a656-7ba0fdc03c16"}
          />
        }
      /> */}
      {/* <Route
        path="/grants/testobtaind"
        element={
          <OpportunitiesObtained
            pR_ReportsStagesGuid={"78563532-98a0-480f-a656-7ba0fdc03c16"}
          />
        }
      /> */}
      <Route
        path="/grants/notetest"
        element={
          <TechnicalReportNotes
            pR_ReportsStagesGuid={"78563532-98a0-480f-a656-7ba0fdc03c16"}
          />
        }
      />
      {/* <Route
        path="/grants/testchallenage"
        element={
          <ChallengesEncountered
            pR_ReportsStagesGuid={"78563532-98a0-480f-a656-7ba0fdc03c16"}
          />
        }
      /> */}
      {/* <Route
        path="/grants/testchallenage"
        element={
          <SuccessStory
            pR_ReportsStagesGuid={"78563532-98a0-480f-a656-7ba0fdc03c16"}
          />
        }
      /> */}
      {/* <Route
        path="/grants/testevent"
        element={
          <EventsActivitiesNextFlow
            pR_ReportsStagesGuid={"78563532-98a0-480f-a656-7ba0fdc03c16"}
          />
        }
      /> */}
      <Route
        path="/grants/InformationProject"
        element={<ProjectInformationPage location="sdsd" />}
      />
      <Route
        path="/grants/InformationProject/InformationProjectSub"
        element={<ProjectInformationModule />}
      />
      <Route
        path="/grants/InformationProject/TargetAudience"
        element={<InformationTargetGroupProjectModule />}
      />
      <Route
        path="/grants/InformationProject/projectPlan"
        element={<ProjectWorkPlanModule />}
      />
      <Route
        path="/grants/InformationProject/ImpactSustainability"
        element={<ExpectedUnoactProjectTargetGroupModule />}
      />
      <Route
        path="/grants/InformationProject/sectorInfo"
        element={<SectoreInformationProjectUniquenessModule />}
      />

      <Route
        path="/grants/InformationProject/TeamPartnerships"
        element={<TeamMembersModule />}
      />
      <Route path="/grants/BudgetTimeFrame" element={<BudgetTimeFrame />} />
      <Route
        path="/grants/AdvertisingAndMediaPlan"
        element={<AdvertisingAndMediaPlan />}
      />
      <Route path="/grants/AttachmentsAndPledge" element={<Attachments />} />
      <Route path="/grants/ReportStage/" element={<ReportsStagesSubmitter />} />
      

         
      <Route
          path="/grants/ReportStageContainer/:stageGuid"
          element={<ReportStageContainer />}
        />
        <Route
          path="/grants/Transfers"
          element={<TransferItemInformationSubmitter />}
        />

    </Routes>
  );
};

export default MainRoutesSupmiter;
